module.exports = __webpack_public_path__ + "static/media/02.7a38d19f.jpg";